import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeFilterPipe} from './tree-filter.pipe';

@NgModule({
  declarations: [TreeFilterPipe],
  exports: [TreeFilterPipe],
  imports: [
    CommonModule
  ]
})
export class TreeFilterPipeModule { }
